import React from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import Header from "../../components/Header";
import Retailer from "../../components/Retailer";
import Firebase from "../../firebasehelper";
import FilterTab from "../super_offers/components/FilterTab";
import AddRetailerModal from "../../components/Retailer/AddRetailerModal";

import {
  getNeoCurrencyToken,
  getNeoCurrencyBrands,
} from "../../functions/RetailerPaymentHelper";

import "./index.css";
import { TerritoryOptions } from "../../Constants/retailer";

const UKIcon = require("../../assets/media/countries/uk.png");
const USAIcon = require("../../assets/media/countries/usa.png");
const IrelandIcon = require("../../assets/media/countries/ireland.png");
const CanadaIcon = require("../../assets/media/countries/canada.png");
const AustraliaIcon = require("../../assets/media/countries/australia.png");
const FranceIcon = require("../../assets/media/countries/france.png");
const GermanIcon = require("../../assets/media/countries/german.png");
const IndiaIcon = require("../../assets/media/countries/india.png");
const SouthAfricaIcon = require("../../assets/media/countries/south-africa.png");

const TerritoryIcon = {
  UK: UKIcon,
  Ireland: IrelandIcon,
  USA: USAIcon,
  Canada: CanadaIcon,
  Australia: AustraliaIcon,
  German: GermanIcon,
  France: FranceIcon,
  India: IndiaIcon,
  SouthAfrica: SouthAfricaIcon,
};
class SuperRetailers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      retailers: [],
      deactive: [],
      tag: "Top 20",
      selectedTerritory:
        this.props.location.state.selectedTerritory || TerritoryOptions[0],
    };
  }
  componentDidMount() {
    if (!this.props.location.state && this.props.location.state.role !== 0) {
      this.props.history.push("/");
    } else {
      const { brand, role, username } = this.props.location.state;
      this.setState({ username, role, brand, loading: true });
    }
    this.setRetailer();
    Firebase.getAllRetailers((res) => {
      // console.log("all retailers", res);
      const keys = Object.keys(res);
      const wgRetailers = keys.map((key) => ({
        ...res[key],
        id: key,
      }));
      Firebase.getAllNCRetailers((res) => {
        const keys = Object.keys(res);
        const ncRetailers = keys.map((key) => ({
          ...res[key],
          id: key,
        }));
        console.log("nc retailers ----", ncRetailers);
        const retailers = [...ncRetailers];
        retailers.sort((a, b) => {
          var textA = a.retailerName.toUpperCase();
          var textB = b.retailerName.toUpperCase();
          return textA < textB ? -1 : textA > textB ? 1 : 0;
        });
        this.setState({ retailers });
      });
    });
    Firebase.getAllDeactiveRetailers((res) => {
      let deactive = [];
      if (res) deactive = res;
      this.setState({ deactive });
    });
  }

  filter_View = (tag) => {
    this.setState({ tag });
  };

  toggleRetailer = (index, voucherType, isActive) => {
    if (voucherType === "neocurrency") {
      console.log("====", index);
      Firebase.updateNCRetailer({ isActive: !isActive }, index);
    } else {
      let { deactive } = this.state;
      deactive[index] = !deactive[index];
      Firebase.updateDeactiveRetailers(deactive);
    }
  };

  goToRetailerDetails = (retailerId, voucherType) => {
    const { brand } = this.state;
    let username = this.props.location.state.username;
    let role = this.props.location.state.role;
    let selectedTerritory = this.state.selectedTerritory;

    this.props.history.push({
      pathname: `/retailer-details`,
      search: `?retailerId=${retailerId}&voucherType=${voucherType}`,
      state: {
        username,
        role,
        brand,
        selectedTerritory,
      },
    });
  };

  territoryFilterUpdated = (selectedTerritory) => () => {
    this.setState({ selectedTerritory });
  };

  onCreateRetailer = (
    retailerName,
    retailerType,
    logo,
    background,
    ecopayLogo,
    territory
  ) => {
    Firebase.addRetailerLogo(retailerName, retailerType, logo).then(
      (logoUrl) => {
        Firebase.addRetailerBackgroundLogo(
          retailerName,
          retailerType,
          background
        ).then((backgroundUrl) => {
          Firebase.addRetailerEcopayLogo(
            retailerName,
            retailerType,
            ecopayLogo
          ).then((ecopayLogo) => {
            Firebase.createRetailer({
              retailerName,
              retailerType,
              logo: logoUrl,
              background: backgroundUrl,
              ecopayLogo,
              territory,
              ecopayRetailer: false,
              ecopassRetailer: false,
              redeemed: {
                fullTokens: 5,
                inStore: true,
                online: true,
                partTokens: 0,
                threshold: "1",
                tokenPercentage: 5,
              },
            });
          });
        });
      }
    );
  };

  showRetailers = () => {
    const { retailers, deactive, tag, selectedTerritory } = this.state;
    let username = this.props.location.state.username;

    let filteredRetailer = [...retailers];
    // if (tag) {
    //   filteredRetailer = filteredRetailer.filter((item) => {
    //     if (tag === "Top 20" && item.top20 && item.top20 !== "none")
    //       return true;
    //     return item.retailerType === tag;
    //   });
    // }

    if (selectedTerritory === "UK") {
      filteredRetailer = filteredRetailer.filter(
        (item) =>
          !item.territory ||
          item.territory === selectedTerritory ||
          item.territory === "GB"
      );
    } else {
      filteredRetailer = filteredRetailer.filter(
        (item) => item.territory === selectedTerritory
      );
    }
    return filteredRetailer.map((retailer, index) => {
      return (
        <Retailer
          key={index}
          deactive={
            retailer.voucherType === "neocurrency"
              ? retailer.isActive
                ? "activate"
                : "deactive"
              : deactive[retailer.id]
              ? "deactive"
              : "activate"
          }
          isSuper={true}
          username={username}
          retailer={retailer}
          retailers={retailers}
          onClick={() =>
            this.toggleRetailer(
              retailer.id,
              retailer.voucherType,
              retailer.isActive
            )
          }
          onEdit={this.goToRetailerDetails}
          id={retailer.id}
        />
      );
    });
  };

  onSaveRetailer = () => {};

  setRetailer = async () => {
    console.log("click");
    const token = await getNeoCurrencyToken();
    console.log("token---", token);
    const ncRetailers = await getNeoCurrencyBrands({
      token: token.access_token,
    });
    console.log("ncRetailers from dashboard", ncRetailers);
    Firebase.getAllNCRetailers((res) => {
      const currentRetailers = Object.keys(res).map((key) => ({
        ...res[key],
      }));
      console.log("current nc", currentRetailers);
      const newRetailers = ncRetailers.filter(
        (retailer) =>
          currentRetailers.findIndex((r) => r.id === retailer.id) < 0
      );
      console.log("new retailers", newRetailers);
      // newRetailers.forEach((retailer) => {
      //   Firebase.createNCRetailer({
      //     id: retailer.id,
      //     background: null,
      //     ecopassRetailer: false,
      //     ecopayIcon: retailer.card_img,
      //     ecopayLogo: retailer.logo,
      //     ecopayRetailer: true,
      //     logo: retailer.logo,
      //     retailerID: retailer.sku || retailer.id,
      //     retailerName: retailer.real_name,
      //     name: retailer.name,
      //     retailerType: retailer.type || "",
      //     territory:
      //       retailer.country_code === "US" ? "USA" : retailer.country_code,
      //     voucherType: "neocurrency",
      //     description: retailer.description,
      //   });
      // });
    });
  };

  render() {
    const { retailers, logo, brand, selectedTerritory, tag } = this.state;
    let username = this.props.location.state.username;
    let role = this.props.location.state.role;

    return (
      <div id="page-container">
        <Header username={username} role={role} logo={logo} brand={brand} />
        <main id="main-container">
          <div className="content">
            {retailers.length ? (
              <React.Fragment>
                {/* <h4>
                  Click the retailer icon to change active or inactive status.
                </h4> */}
                <div className="territory-filter-container">
                  {TerritoryOptions.map((territory) => (
                    <button
                      className={classNames("btn territory-btn", {
                        selected: selectedTerritory === territory,
                      })}
                      onClick={this.territoryFilterUpdated(territory)}
                    >
                      <img src={TerritoryIcon[territory]} alt="flag" />
                    </button>
                  ))}
                </div>
                {/* <FilterTab filter_View={this.filter_View} tag={tag} /> */}
                {this.showRetailers()}
                <button
                  type="button"
                  className="btn btn-secondary add_btn"
                  data-toggle="modal"
                  data-target="#retailer-modal"
                >
                  Add New Token Retailer
                </button>
              </React.Fragment>
            ) : (
              <i className="fa fa-4x fa-sync fa-spin text-muted" />
            )}
          </div>
        </main>
        <AddRetailerModal
          retailers={retailers}
          onSave={this.onCreateRetailer}
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => ({});
const mapActionToProps = (dispatch) => ({});
export default connect(mapStateToProps, mapActionToProps)(SuperRetailers);



// WEBPACK FOOTER //
// ./src/screens/super_retailers/index.js